import {IConfig} from "angular8-yandex-maps";

export const mapConfig: IConfig = {
	apikey: null,
	lang: 'ru_RU',
};
